(function() {
	'use strict';
	angular.module('quantixApp')
	.factory('baseRequest',baseRequest);
	baseRequest.$inject = ['$q','$http'];
function baseRequest($q,$http) {
    return function (api, param, verb) {
        verb = verb || 'post';
        var defer = $q.defer();
        $http.post(api,param)
            .then(function (response, status) { defer.resolve(response, status); },
            function (response, status) { defer.reject(response, status); }
            );
        return defer.promise;
    }
}
})();